import { NgModule } from '@angular/core';

import { CssVariablesService } from '@backbase/ui-ang/css-variables-lib';
import { MediaQueryService } from './media-query.service';

/**
 * Provides media query services for responsive design implementation.
 *
 * @remarks
 * This module configures the {@link MediaQueryService} and {@link CssVariablesService} providers
 * for detecting screen size changes and managing CSS breakpoints. Essential for components
 * that need to adapt behavior based on viewport dimensions or screen breakpoints.
 *
 * @example
 *
 * ```typescript
 * @NgModule({
 *   imports: [MediaQueryModule],
 *   declarations: [TrackerComponent, TrackerSegmentComponent],
 *   exports: [TrackerComponent, TrackerSegmentComponent],
 * })
 * export class TrackerModule {}
 * ```
 */
@NgModule({
  providers: [CssVariablesService, MediaQueryService],
})
export class MediaQueryModule {}
